import { PageHeader } from "@/widgets/page-header"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { CreateGroup } from "@/features/groups/ui/create-group"
import { GroupsGrid } from "./groups-grid"

export const EmployeesGroupsPage = () => {
    return (
        <div className="_page_container">
            <PageHeader title="Сотрудники" />
            <div className="flexbox">
                <PageSubtitle title={'Группы'} />
                <div className="w-full flex justify-end gap-2">
                    <div className="w-full bg-white h-[52px] rounded-full block"/>
                    <CreateGroup 
                        role={"employees"}                  
                    />
                </div>
                <GroupsGrid />
            </div>
        </div>
    )
}